.comments-container {
  border-radius: 0 0 1.6rem 0;
  flex: 1;
  overflow-y: auto;
  scroll-behavior: smooth;
  position: relative;

  @media screen and (max-width: #{$bp-medium - 1}) {
    padding-bottom: 12rem;
  }
}

.comment-container {
  border-left: 0.2rem solid;
  border-left-color: transparent;
  padding-inline-end: calc(0.8rem - 100vw + 100%);

  @media screen and (min-width: $bp-medium) {
    padding-inline-end: min(1.2rem - (40rem - 100%), 1.2rem);
  }

  & > :not(:first-child) {
    margin-inline-start: 1.6rem;
  }

  &:hover {
    cursor: pointer;

    &:not([data-selected='true']) {
      background-color: var(--color-grayscale-charleston);
    }
  }

  &[data-selected='true'] {
    border-left-color: var(--color-shades-hibiscus);
  }
}
